export const FORM_NEW = "FORM/NEW";
export const FORM_GET = "FORM_GET";
export const FORM_MERGE_UPDATE = "FORM/MERGE_UPDATE";
export const FORM_READY = "FORM/READY";
export const FORM_REMOVE = "FORM/REMOVE";
export const FORM_STATUS_UPDATE = "FORM/STATUS_UPDATE";
export const FORM_SET_MESSAGE = "FORM/SET_MESSAGE";
export const FORM_CLEAR_MESSAGE = "FORM/CLEAR_MESSAGE";

export const SEND_PATCHES = "SEND_PATCHES";
export const JSON_PATCH = "JSON_PATCH";
export const JSON_PATCH_SUCCESS = "JSON_PATCH_SUCCESS";
export const FORM_SAVE = "FORM_SAVE";
export const FORM_SAVE_CLOSE = "FORM_SAVE_CLOSE";
export const FORM_CLOSE = "FORM_CLOSE";
